<div class="addContainer">
    <div class="modalHeader">
      <div class="editRowModal">
        <div class="modalHeader clearfix">
          <div class="modalHeader clearfix">
            <div class="modal-about">
              <div class="font-weight-bold p-t-5 ms-2 me-2 font-17">
                Add {{ childLevelLabel }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        mat-icon-button
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div mat-dialog-content>
      <form class="register-form m-4" [formGroup]="addStationForm">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
            <label class="plain-label" for="outStationName">{{ childLevelLabel }} *</label>
            <mat-form-field class="example-full-width" appearance="outline">
              <!-- <mat-label>Outstation Name</mat-label> -->
              <input matInput formControlName="outStationName" required />
              <mat-error *ngIf="addStationForm.get('outStationName').hasError('required')">
                {{ childLevelLabel }} is required
              </mat-error>
            </mat-form-field>
          </div>  
        
    
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
            <label class="plain-label" for="outStationLocation">{{ childLevelLabel }} Location *</label>
            <mat-form-field class="example-full-width" appearance="outline">
              <!-- <mat-label>OutStation Location</mat-label> -->
              <input matInput formControlName="outStationLocation" required />
              <mat-error *ngIf="addStationForm.get('outStationLocation').hasError('required')">
                {{ childLevelLabel }} Location  is required
              </mat-error>
            </mat-form-field>
          </div>
        
        </div>
  
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
            <div class="example-button-row" align="end">
              <button style="background-color: #48B5E1; color: #FFFFFF;"
                mat-raised-button
                [disabled]="!addStationForm.valid" (click)="submit()"
              >
                Save
              </button>
               <button style="background-color: #312B2A; color: #FFFFFF;"
                mat-raised-button
                (click)="onClick()"
                tabindex="-1"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  